/// <amd-module name="VC/Search/SearchHelp" />
import React = require("react");
import Resources = require("VC/Search/Resources");
import { ISearchInput } from "VSS/Platform/Search";
import { ISearchFilter, SearchHelpComponent } from "VSS/Features/Search/SearchHelp";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { VssComponent } from "VSS/Platform/Layout";

const CodeTypeFeatureFlag: string = "WebAccess.Search.Code.EnableRationalizedListOfCodeElementFilters";

export interface IVersionControlSearchHelpComponentProps {
    searchInput: ISearchInput;

    onItemActivated?: (item: ISearchFilter) => void;
}

export class VersionControlSearchHelpComponent extends VssComponent<IVersionControlSearchHelpComponentProps> {
    public render(): JSX.Element {
        let codeTypeFiltersList;
        const scopeFiltersList = [
            {
                text: "ext:",
                hint: Resources.ExtensionHint
            },
            {
                text: "file:",
                hint: Resources.FilenameHint
            },
            {
                text: "path:",
                hint: Resources.PathHint
            },
            {
                text: "proj:",
                hint: Resources.ProjectHint
            },
            {
                text: "repo:",
                hint: Resources.RepoHint
            }
        ];
        if (isFeatureFlagEnabled(this.context.pageContext, CodeTypeFeatureFlag, false)) {
            codeTypeFiltersList = [
                {
                    text: "basetype:",
                    hint: Resources.BaseTypeHint
                },
                {
                    text: "class:",
                    hint: Resources.ClassHint
                },
                {
                    text: "comment:",
                    hint: Resources.CommentHint
                },
                {
                    text: "decl:",
                    hint: Resources.DeclarationHint
                },
                {
                    text: "def:",
                    hint: Resources.DefinitionHint
                },
                {
                    text: "enum:",
                    hint: Resources.EnumHint
                },
                {
                    text: "field:",
                    hint: Resources.FieldHint
                },
                {
                    text: "interface:",
                    hint: Resources.InterfaceHint
                },
                {
                    text: "macro:",
                    hint: Resources.MacroHint
                },
                {
                    text: "method:",
                    hint: Resources.MethodHint
                },
                {
                    text: "namespace:",
                    hint: Resources.NamespaceHint
                },
                {
                    text: "ref:",
                    hint: Resources.ReferenceHint
                },
                {
                    text: "strlit:",
                    hint: Resources.StringLitHint
                },
                {
                    text: "type:",
                    hint: Resources.TypeHint
                }
            ];
        }
        else {
            codeTypeFiltersList = [
                {
                    text: "arg:",
                    hint: Resources.ArgumentHint
                },
                {
                    text: "basetype:",
                    hint: Resources.BaseTypeHint
                },
                {
                    text: "caller:",
                    hint: Resources.CallerHint
                },
                {
                    text: "class:",
                    hint: Resources.ClassHint
                },
                {
                    text: "classdecl:",
                    hint: Resources.CDeclHint
                },
                {
                    text: "classdef:",
                    hint: Resources.CDefHint
                },
                {
                    text: "comment:",
                    hint: Resources.CommentHint
                },
                {
                    text: "ctor:",
                    hint: Resources.ConstructorHint
                },
                {
                    text: "decl:",
                    hint: Resources.DeclarationHint
                },
                {
                    text: "def:",
                    hint: Resources.DefinitionHint
                },
                {
                    text: "dtor:",
                    hint: Resources.DestructorHint
                },
                {
                    text: "enum:",
                    hint: Resources.EnumHint
                },
                {
                    text: "extern:",
                    hint: Resources.ExternHint
                },
                {
                    text: "field:",
                    hint: Resources.FieldHint
                },
                {
                    text: "friend:",
                    hint: Resources.FriendHint
                },
                {
                    text: "func:",
                    hint: Resources.FuncHint
                },
                {
                    text: "funcdecl:",
                    hint: Resources.FuncDeclHint
                },
                {
                    text: "funcdef:",
                    hint: Resources.FuncDefHint
                },
                {
                    text: "global:",
                    hint: Resources.GlobalHint
                },
                {
                    text: "header:",
                    hint: Resources.HeaderHint
                },
                {
                    text: "interface:",
                    hint: Resources.InterfaceHint
                },
                {
                    text: "macro:",
                    hint: Resources.MacroHint
                },
                {
                    text: "macrodef:",
                    hint: Resources.MacroDefHint
                },
                {
                    text: "macroref:",
                    hint: Resources.MacroRefHint
                },
                {
                    text: "method:",
                    hint: Resources.MethodHint
                },
                {
                    text: "methoddecl:",
                    hint: Resources.MethodDeclHint
                },
                {
                    text: "methoddef:",
                    hint: Resources.MethodDefHint
                },
                {
                    text: "namespace:",
                    hint: Resources.NamespaceHint
                },
                {
                    text: "prop:",
                    hint: Resources.PropertyHint
                },
                {
                    text: "ref:",
                    hint: Resources.ReferenceHint
                },
                {
                    text: "strlit:",
                    hint: Resources.StringLitHint
                },
                {
                    text: "struct:",
                    hint: Resources.StructHint
                },
                {
                    text: "structdecl:",
                    hint: Resources.StructDeclHint
                },
                {
                    text: "structdef:",
                    hint: Resources.StructDefHint
                },
                {
                    text: "tmplarg:",
                    hint: Resources.TemplateArgHint
                },
                {
                    text: "tmplspec:",
                    hint: Resources.TemplateSpecHint
                },
                {
                    text: "type:",
                    hint: Resources.TypeHint
                },
                {
                    text: "typedef:",
                    hint: Resources.TypeDefHint
                },
                {
                    text: "union:",
                    hint: Resources.UnionHint
                }
            ];
        }
        return (
            <SearchHelpComponent
                filterGroups={[
                    {
                        "caption": Resources.Filters,
                        "example": Resources.FilterByScopeExample,
                        "filters": scopeFiltersList.concat(codeTypeFiltersList)
                    },
                    {
                        "caption": Resources.Operators,
                        "example": Resources.OperatorsExample,
                        "singleLine": true,
                        "filters": [
                            {
                                "text": "AND"
                            },
                            {
                                "text": "NOT"
                            },
                            {
                                "text": "OR"
                            }
                        ]
                    }
                ]}
                helpLink="https://go.microsoft.com/fwlink/?linkid=859315"
                searchInput={this.props.searchInput}
                onItemActivated={this.props.onItemActivated}
            />
        );
    }
}

VssComponent.register("ms.vss-code-web.search-content.search-help", VersionControlSearchHelpComponent);